/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedPublishsetListListResponse } from '../types/PaginatedPublishsetListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PublishsetsListRequest = {} | null | undefined;
export type PublishsetsListResponse = PaginatedPublishsetListListResponse;

export type PublishsetsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: admin_only
   * schema:
   *   type: boolean
   * ```
   */
  admin_only?: boolean;

  /**
   * ```yaml
   * in: query
   * name: creator
   * schema:
   *   type: string
   * description: Creator
   * ```
   */
  creator?: string;

  /**
   * ```yaml
   * in: query
   * name: editor
   * schema:
   *   type: string
   * description: Editor
   * ```
   */
  editor?: string;

  /**
   * ```yaml
   * in: query
   * name: from_primary_db
   * schema:
   *   type: boolean
   * description: Order from primary db
   * ```
   */
  from_primary_db?: boolean;

  /**
   * ```yaml
   * in: query
   * name: is_paid
   * schema:
   *   type: boolean
   * description: Paid publishsets
   * ```
   */
  is_paid?: boolean;

  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: only_jvf
   * schema:
   *   type: boolean
   * description: Only JVF and custom
   * ```
   */
  only_jvf?: boolean;

  /**
   * ```yaml
   * in: query
   * name: order_is_public
   * schema:
   *   type: boolean
   * description: Order is public
   * ```
   */
  order_is_public?: boolean;

  /**
   * ```yaml
   * in: query
   * name: order_selection_type
   * schema:
   *   type: string
   *   enum:
   *     - CUSTOM
   *     - PACKAGE
   * description: |-
   *   Selection type
   *
   *   * `CUSTOM` - Custom
   *   * `PACKAGE` - Package
   * ```
   */
  order_selection_type?: 'CUSTOM' | 'PACKAGE';

  /**
   * ```yaml
   * in: query
   * name: order_type
   * schema:
   *   type: string
   *   enum:
   *     - CHANGE
   *     - STATE
   * description: |-
   *   Order type
   *
   *   * `STATE` - State
   *   * `CHANGE` - Change
   * ```
   */
  order_type?: 'CHANGE' | 'STATE';

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: state
   * schema:
   *   type: string
   *   enum:
   *     - ARCHIVED
   *     - PREPARING
   *     - PUBLISHED
   * description: |-
   *   * `PREPARING` - PREPARING
   *   * `PUBLISHED` - PUBLISHED
   *   * `ARCHIVED` - ARCHIVED
   * ```
   */
  state?: 'ARCHIVED' | 'PREPARING' | 'PUBLISHED';

  /**
   * ```yaml
   * in: query
   * name: tags__name
   * schema:
   *   type: string
   * ```
   */
  tags__name?: string;

  /**
   * ```yaml
   * in: query
   * name: tags__name__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   * explode: true
   * style: form
   * ```
   */
  tags__name__in?: string[];

  /**
   * ```yaml
   * in: query
   * name: type
   * schema:
   *   type: string
   *   nullable: true
   *   enum:
   *     - RASTER
   *     - VECTOR
   * description: |-
   *   * `VECTOR` - VECTOR
   *   * `RASTER` - RASTER
   * ```
   */
  type?: ('RASTER' | 'VECTOR') | null;
};

/**
 * GET /dmx-server/publishsets/
 *
 * ```yaml
 * operationId: publishsets_list
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPublishsetListList'
 *     description: ''
 * ```
 */
export const publishsetsListOperation = (rest?: PublishsetsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/publishsets/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/publishsets/' };
  };

/**
 * GET /dmx-server/publishsets/
 *
 * ```yaml
 * operationId: publishsets_list
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPublishsetListList'
 *     description: ''
 * ```
 */
export const publishsetsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PublishsetsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedPublishsetListListResponse>> => {
  const operation = publishsetsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/publishsets/
 */
export const usePublishsetsListResource = (
  query: PublishsetsListQuery | null,
  useCached?: boolean,
): UseResource<PublishsetsListResponse> => {
  return useResource<PublishsetsListResponse>({
    path: query === null ? null : publishsetsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
